import { Koi } from '@ksyos/koi';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';

export type RespiAllerQuestionnaireCustomControlData = {
    patientQuestionnaireUrl: string;
    processQuestionnaireResponseId?: string;
    questionnaireResponse: unknown;
};

const respiAllerQuestionnaireFinalBaseSchema: TypedSchema<RespiAllerQuestionnaireCustomControlData> = {
    patientQuestionnaireUrl: Koi.string().uri().max(1_000),
    processQuestionnaireResponseId: Koi.string().uuid().optional(),
    questionnaireResponse: Koi.object().unknown(true).optional(),
};

export const respiAllerQuestionnaireFinalSchema = Koi.object(respiAllerQuestionnaireFinalBaseSchema);
export const respiAllerQuestionnaireDraftSchema = Koi.object(respiAllerQuestionnaireFinalBaseSchema);
